module.exports = __webpack_public_path__ + "img/why-ico4.a793aae1.png";